// import "swing-ui/vendor/owl.carousel/dist/assets/owl.carousel.css";
// import "swing-ui/vendor/owl.carousel/dist/assets/owl.theme.default.css";
import "../assets/less/main.less";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App/App";

createRoot(document.getElementById("sponsors-email-child-app")).render(<App />);
